export default __webpack_public_path__ + "fonts/Circular-Bold.ttf";